// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1134 ? "63a829c1" : chunkId) + "." + {"1134":"8eb294977bc5d18b","3091":"691b3fd36bb01f4f","9167":"a4d3852166e1e41c"}[chunkId] + ".js";
};